import { componentStyleWithExtend } from '@/styling/util/component-style.ts';
import type { MenuDesignTokens } from '@primeuix/themes/types/menu';

export const menuStyle: ReturnType<typeof componentStyleWithExtend<MenuDesignTokens>> =
    componentStyleWithExtend<MenuDesignTokens>({
        extend: {
            root: {
                border: '1px solid {content.border.color}',
            },
        },
        style: {
            root: {
                borderRadius: '4px',
            },
        },
        css: ({ dt }) => `
        .p-menu {
            padding: 0;
        }
    `,
    });
